import { Text } from "./typography";

export type BadgeState = "success" | "error" | "pending" | "info";

type BadgeProps = {
  label: string;
  state: BadgeState;
};

export function Badge({ label, state }: BadgeProps) {
  const cs = [
    state === "success" ? "bg-green-100 ring-green-200" : "",
    state === "error" ? "bg-primary/10 ring-primary/20" : "",
    state === "pending" ? "bg-warning/10 ring-warning/20" : "",
    state === "info" ? "bg-blue-100 ring-blue-200" : "",
  ];

  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-1 ring-1 ring-inset ${cs.join(
        " "
      )}`}
    >
      <Text variant="bodyXs">
        {label}
      </Text>
    </span>
  );
}
